
import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿Cuánto tarda la tasación de mi coche en Barcelona?',
      answer: 'Nuestro equipo de expertos realiza la tasación en menos de 24 horas. Solo necesitas rellenar el formulario con los datos básicos de tu vehículo y te contactaremos con una oferta competitiva. Somos el desguace más rápido de Barcelona en dar respuesta.'
    },
    {
      question: '¿Compran coches siniestrados o accidentados en Barcelona?',
      answer: 'Sí, compramos todo tipo de vehículos siniestrados, accidentados o con daños graves en Barcelona y toda la provincia. No importa el estado del coche, siempre ofrecemos el mejor precio del mercado. Tenemos más de 15 años de experiencia gestionando vehículos siniestrados.'
    },
    {
      question: '¿Qué documentación necesito para vender mi coche al desguace?',
      answer: 'Necesitas el DNI del titular, permiso de circulación y ficha técnica del vehículo. Nosotros nos encargamos de todos los trámites legales, incluido el certificado de destrucción y la baja definitiva en Tráfico. Todo el proceso es 100% legal y seguro.'
    },
    {
      question: '¿Recogen el coche gratis en toda Barcelona?',
      answer: 'Sí, ofrecemos servicio de recogida gratuita en Barcelona capital y toda la provincia: Badalona, L\'Hospitalet, Sabadell, Terrassa, Mataró, Granollers y alrededores. Acordamos día y hora que mejor te convenga sin ningún coste adicional.'
    },
    {
      question: '¿Cómo y cuándo recibo el pago por mi coche?',
      answer: 'El pago es inmediato. Una vez recogemos el vehículo y verificamos la documentación, realizamos la transferencia bancaria o pago en efectivo en el momento. Tú eliges la forma de pago que prefieras. Sin esperas ni complicaciones.'
    },
    {
      question: '¿Compran coches sin ITV o con la ITV caducada?',
      answer: 'Por supuesto. Compramos vehículos sin ITV, con ITV caducada o que no puedan pasar la inspección técnica. Es uno de nuestros servicios más demandados en Barcelona. No importa cuánto tiempo lleve sin ITV, te hacemos una oferta justa.'
    },
    {
      question: '¿Qué diferencia hay entre vender a un desguace o a un particular?',
      answer: 'Vender a Desguace Barcelona es mucho más rápido, seguro y sin complicaciones. No necesitas anuncios, visitas de desconocidos ni negociaciones. Nosotros nos encargamos de todo: tasación, recogida, trámites legales y pago inmediato. Además, garantizamos el mejor precio.'
    },
    {
      question: '¿Compran motos, furgonetas o vehículos comerciales?',
      answer: 'Sí, además de coches compramos motos, furgonetas, vehículos comerciales y todo tipo de vehículos en cualquier estado. Nuestro servicio abarca todo tipo de vehículos en Barcelona y provincia. Solicita tasación sin compromiso.'
    }
  ];

  return (
    <section className="py-24 bg-[#f8f9fa]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-black text-[#1a2332] mb-4">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-gray-600">
            Resolvemos todas tus dudas sobre vender tu coche en Barcelona
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer"
              >
                <h3 className="text-lg font-bold text-[#1a2332] pr-4">{faq.question}</h3>
                <i className={`ri-arrow-down-s-line text-2xl text-[#ff6b35] transition-transform flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">¿Tienes más preguntas?</p>
          <a 
            href="#contacto" 
            className="inline-flex items-center px-8 py-4 bg-[#1a2332] text-white rounded-full font-bold hover:bg-[#2d3e50] transition-all whitespace-nowrap cursor-pointer"
          >
            Contacta con nosotros
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
